/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_StatusInputs */

const en_wb_operations_status = /** @type {(inputs: Wb_Operations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepared from email`)
};

const lv_wb_operations_status = /** @type {(inputs: Wb_Operations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavots no e-pasta`)
};

/**
* | output |
* | --- |
* | "Prepared from email" |
*
* @param {Wb_Operations_StatusInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_status = /** @type {((inputs?: Wb_Operations_StatusInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_StatusInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_status(inputs)
	return en_wb_operations_status(inputs)
});